import { RepositoryFactory } from '@/repositories/repositoryFactory'
import { defineStore } from 'pinia'
import { StorageHelper } from '@/helpers/storage-helper'

interface AppError {
  message: string
}

interface PrivacyPolicyData {
  data: any
  loading: boolean
  error: AppError | null
  initialized: boolean
}

const PrivacyPolicyRepository: any = RepositoryFactory.get('PrivacyPolicyRepository')

export const usePrivacyPolicyStore = defineStore('privacyPolicy', {
  state: () =>
    <PrivacyPolicyData>{
      data: StorageHelper.getItem('privacyPolicyData', []),
      error: null,
      loading: true
    },
  getters: {
    getPrivacyPolicyData: (state) => state.data
  },
  actions: {
    async fetchPrivacyPolicyData() {
      this.loading = true
      try {
        this.data = (await PrivacyPolicyRepository.getPrivacyPolicyData()).data.fields
        StorageHelper.setItem('privacyPolicyData', this.data)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching privacy policy data'
        }
        throw error
      } finally {
        this.loading = false
      }
    }
  }
})
